import { NotificationType } from "@cnx/common";
import { Center } from "@mantine/core";
import { IconRoute } from "@tabler/icons-react";
import IconAlertOctagon from "icons/notification/alert-octagon.svg";

const defaultStopIcon = (iconSize: number, size: number) => (
  <Center w={size} h={size} className="bg-[#DAC109] text-white rounded-full">
    <IconAlertOctagon
      className="text-white"
      width={iconSize}
      height={iconSize}
    />
  </Center>
);

const defaultCancelIcon = (iconSize: number, size: number) => (
  <Center w={size} h={size} className="bg-red-dark text-white rounded-full">
    <IconAlertOctagon
      className="text-white"
      width={iconSize}
      height={iconSize}
    />
  </Center>
);

const notificationTypeToIconMap = {
  [NotificationType.NEW_TRIP]: (iconSize: number, size: number) => (
    <Center w={size} h={size} className="bg-green text-white rounded-full">
      <IconRoute size={iconSize} />
    </Center>
  ),
  [NotificationType.NEW_SHIPMENT]: (iconSize: number, size: number) => (
    <Center w={size} h={size} className="bg-blue text-white rounded-full">
      <IconAlertOctagon
        className="text-white"
        width={iconSize}
        height={iconSize}
      />
    </Center>
  ),
  [NotificationType.NEW_STOP]: defaultStopIcon,
  [NotificationType.NEW_STOP_BEFORE_DRIVING]: defaultStopIcon,
  [NotificationType.NEW_STOP_BEFORE_LOCATION]: defaultStopIcon,
  [NotificationType.NEW_STOP_AFTER_CURRENT]: defaultStopIcon,
  [NotificationType.NEW_ROW_TO_CURRENT_STOP]: defaultStopIcon,

  [NotificationType.CHANGES_TO_CURRENT_STOP_DRIVING]: defaultStopIcon,
  [NotificationType.CHANGES_TO_CURRENT_STOP_ON_LOCATION]: defaultStopIcon,
  [NotificationType.CHANGES_TO_STOP]: defaultStopIcon,

  [NotificationType.CANCELED_RESOURCE_COMBINATION]: defaultCancelIcon,
  [NotificationType.CANCELED_STOP]: defaultCancelIcon,
  [NotificationType.CANCELED_CURRENT_STOP]: defaultCancelIcon,
  [NotificationType.CANCELED_ROW]: defaultCancelIcon,
  [NotificationType.CANCELED_ROW_FROM_CURRENT_STOP]: defaultCancelIcon,
};

export const selectIconByNotificationType = (options: {
  notificationType: NotificationType;
  iconSize?: number;
  size?: number;
}) => {
  const { notificationType, iconSize = 24, size = 50 } = options;
  const iconCreator = notificationTypeToIconMap[notificationType];
  return typeof iconCreator === "function" ? iconCreator(iconSize, size) : null;
};
